import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { LoadingService } from '@mds/ngx-core';
import { EMPTY, finalize, first } from 'rxjs';
import { VehicleResponse, VehiclesClient } from '../../shared';

export const vehicleResolver: ResolveFn<VehicleResponse> = (
  route: ActivatedRouteSnapshot,
) => {
  const vehiclesClient = inject(VehiclesClient);
  const loadingService = inject(LoadingService);
  const router = inject(Router);

  const vehicleId = Number(route.paramMap.get('vehicleId'));

  if (Number.isNaN(vehicleId)) {
    void router.navigate(['vehicle']);
    return EMPTY;
  }

  loadingService.start();

  return vehiclesClient.getVehicleById(vehicleId).pipe(
    first(),
    finalize(() => loadingService.end()),
  );
};
